// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Image/arrowDownIcon.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  text-decoration: none !important;
  outline: none !important;
}
*::-webkit-scrollbar {
  width: 0.25rem !important;
  height: 0.25rem !important;
}
*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0.3rem rgba(0, 0, 0, 0.3);
}
*::-webkit-scrollbar-thumb {
  background-color: #2056a5;
  outline: none;
}
*:focus {
  box-shadow: none !important;
}

html {
  font-size: 20px;
}
@media (max-width: 1439px) {
  html {
    font-size: 18px;
  }
}
@media (max-width: 1365px) {
  html {
    font-size: 16px;
  }
}
@media (max-width: 1023px) {
  html {
    font-size: 12px;
  }
}
body {
  font-size: 0.8rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  line-height: 1.4;
  color: #6e6b7b;
}

.ml-0 {
  margin-left: 0 !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.badge.bg-primary {
  background-color: #2056a5 !important;
}
.badge.bg-success {
  background-color: #71d875 !important;
}
.badge.bg-warning {
  background-color: #f99240 !important;
}

.mt40 {
  margin-top: 40px;
}

.container-fluid,
.container {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.container {
  width: 96%;
  max-width: 1440px;
}

.row {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

[class*=col-] {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.table {
  white-space: nowrap !important;
}
.table thead th,
.table thead td,
.table tbody th,
.table tbody td,
.table tfoot th,
.table tfoot td {
  padding: 0.6rem !important;
  text-align: center;
}

#customerGroup {
  white-space: nowrap !important;
}
#customerGroup thead th,
#customerGroup thead td,
#customerGroup tbody th,
#customerGroup tbody td,
#customerGroup tfoot th,
#customerGroup tfoot td {
  padding: 0.6rem !important;
  text-align: left !important;
}

.form-group {
  margin: 0 0 1rem;
}

.form-control,
.css-13cymwt-control,
.css-1s2u09g-control {
  border-radius: 0.375rem;
  background-color: #fafafa !important;
  border-color: #ccc;
}
.form-control:hover,
.css-13cymwt-control:hover,
.css-1s2u09g-control:hover {
  border-color: #86b7fe !important;
}

input[type=text].form-control,
input[type=date].form-control,
textarea.form-control,
.css-319lph-ValueContainer,
.css-1fdsijx-ValueContainer,
.css-1d8n9bt {
  font-size: 1rem;
  padding: 0.45rem 0.9rem !important;
}

input[type=date].form-control {
  font-size: 0.8rem;
  padding: 0.375rem 0.75rem !important;
}

.modal-header,
.modal-body,
.modal-footer {
  padding: 0.75rem !important;
}

.modal-header {
  background-color: #2056a5;
}
.modal-header .modal-title,
.modal-header .btn-close {
  color: #ffffff;
  opacity: 1;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  border-radius: 0.3rem;
  transition: all 0.5s ease;
}
.btn.btn-sm {
  padding: 0.15rem 0.45rem;
  font-size: 0.6rem;
}
.btn.btn-lg {
  padding: 0.6rem 1.8rem;
  font-size: 1rem;
}
.btn.btn-xl {
  padding: 0.8rem 2.4rem;
  font-size: 1.2rem;
}
.btn.btn-primary {
  background-color: #2056a5;
  color: white;
  border: 1px solid #2056a5;
}
.btn.btn-primary:hover {
  background-color: #1b427c;
  color: white;
}
.btn.btn-outline-primary {
  color: #2056a5;
  background-color: white;
  border: 1px solid #2056a5;
}
.btn.btn-outline-primary:hover {
  background-color: #2056a5;
  color: white;
}

textarea.form-control {
  min-height: 5rem !important;
  resize: none !important;
}

.form-control {
  font-size: 0.8rem;
}

img {
  max-width: 100%;
}

.characterLimitProperty {
  font-weight: 400;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.textValidatorError {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.25rem;
  color: red;
}
.textValidatorError p {
  display: flex;
  flex-direction: column;
  font-size: 0.6rem;
  font-weight: 700;
  line-height: 1.5;
  color: #8b8c8c;
  margin: 0 0 0.5rem;
}
.textValidatorError p:nth-last-child(1) {
  margin-bottom: 0;
}
.textValidatorError p span {
  display: block;
}
.textValidatorError p span.passwordAdded {
  color: #50bc14;
}
.textValidatorError ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
}
.textValidatorError ul li {
  display: flex;
  flex-direction: column;
  font-size: 0.6rem;
  font-weight: 700;
  line-height: 1.5;
  color: #8b8c8c;
  margin: 0 0.5rem 0.5rem 0;
}
.textValidatorError ul li:nth-last-child(1) {
  margin-bottom: 0;
}
.textValidatorError ul li span {
  display: block;
}
.textValidatorError ul li span.passwordAdded {
  color: #50bc14;
}

.selectArrow {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 0.5rem center/0.6rem auto;
  padding-right: 1.2rem !important;
}
@media (max-width: 767px) {
  .selectArrow {
    background-position: right 0.25rem center;
  }
}

.errorMessage {
  color: red !important;
}

.successMessage {
  color: #50bc14 !important;
}

.dashboard__transactionsModal {
  display: flex;
  flex-direction: column;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails {
  display: flex;
  flex-direction: column;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails:nth-child(1) {
  width: 100%;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails:nth-child(1) .dashboard__transactionsModalBottom {
  display: flex;
  flex-direction: column;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails:nth-child(1) .dashboard__transactionsModalBottom ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 0 0.5rem;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails:nth-child(1) .dashboard__transactionsModalBottom ul:last-child {
  margin-bottom: 0;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails:nth-child(1) .dashboard__transactionsModalBottom ul li {
  width: 50%;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails:nth-child(1) .dashboard__transactionsModalBottom ul li:nth-last-child(2), .dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails:nth-child(1) .dashboard__transactionsModalBottom ul li:nth-last-child(1) {
  margin: 0;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails:nth-child(1) .dashboard__transactionsModalBottom ul li:nth-child(1) {
  padding-left: 0;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails:nth-child(2) {
  width: 50%;
  padding-right: 1rem;
  border-right: 0.05rem solid #dee2e6;
  margin-top: 1.5rem;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails:nth-child(3) {
  width: 50%;
  padding-left: 1rem;
  margin-top: 1.5rem;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalTop {
  display: flex;
  flex-direction: column;
  margin: 0 0 1rem;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalTop h2 {
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.2;
  color: #282828;
  margin: 0;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalBottom {
  display: flex;
  flex-direction: column;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalBottom ul {
  display: flex;
  flex-direction: column;
  padding: 0 0 0.5rem;
  border-bottom: 0.05rem solid #dee2e6;
  margin: 0 0 0.5rem;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalBottom ul:last-child {
  padding: 0;
  border-bottom: none;
  margin: 0;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalBottom ul li {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 1.2;
  color: #282828;
  margin: 0 0 0.7rem;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalBottom ul li:last-child {
  margin-bottom: 0;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalBottom ul li span {
  display: inline-block;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalBottom ul li span:last-child {
  font-weight: 400;
  max-width: calc(100% - 8rem);
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalBottom ul li span:first-child {
  font-weight: 600;
  margin-right: 0.5rem;
}
.dashboard__transactionsModal .dashboard__transactionsModalProfile .dashboard__transactionsModalDetails .dashboard__transactionsModalBottom ul li a {
  display: inline-block;
}

.mainPreloaderMain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 242, 242, 0.9);
  z-index: 99999;
}
.mainPreloaderMain .mainPreloader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 4rem;
  height: 4rem;
  z-index: 99999;
}
.mainPreloaderMain .mainPreloader div {
  animation: mainPreloader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 2rem 2rem;
}
.mainPreloaderMain .mainPreloader div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 0.35rem;
  height: 0.35rem;
  border-radius: 50%;
  background: #2056a5;
  margin: -0.2rem 0 0 -0.2rem;
}
.mainPreloaderMain .mainPreloader div:nth-child(1) {
  animation-delay: -0.036s;
}
.mainPreloaderMain .mainPreloader div:nth-child(1):after {
  top: 3.15rem;
  left: 3.15rem;
}
.mainPreloaderMain .mainPreloader div:nth-child(2) {
  animation-delay: -0.072s;
}
.mainPreloaderMain .mainPreloader div:nth-child(2):after {
  top: 3.4rem;
  left: 2.8rem;
}
.mainPreloaderMain .mainPreloader div:nth-child(3) {
  animation-delay: -0.108s;
}
.mainPreloaderMain .mainPreloader div:nth-child(3):after {
  top: 3.55rem;
  left: 2.4rem;
}
.mainPreloaderMain .mainPreloader div:nth-child(4) {
  animation-delay: -0.144s;
}
.mainPreloaderMain .mainPreloader div:nth-child(4):after {
  top: 3.6rem;
  left: 2rem;
}
.mainPreloaderMain .mainPreloader div:nth-child(5) {
  animation-delay: -0.18s;
}
.mainPreloaderMain .mainPreloader div:nth-child(5):after {
  top: 3.55rem;
  left: 1.6rem;
}
.mainPreloaderMain .mainPreloader div:nth-child(6) {
  animation-delay: -0.216s;
}
.mainPreloaderMain .mainPreloader div:nth-child(6):after {
  top: 3.4rem;
  left: 1.2rem;
}
.mainPreloaderMain .mainPreloader div:nth-child(7) {
  animation-delay: -0.252s;
}
.mainPreloaderMain .mainPreloader div:nth-child(7):after {
  top: 3.15rem;
  left: 0.85rem;
}
.mainPreloaderMain .mainPreloader div:nth-child(8) {
  animation-delay: -0.288s;
}
.mainPreloaderMain .mainPreloader div:nth-child(8):after {
  top: 2.8rem;
  left: 0.6rem;
}

@keyframes mainPreloader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes progressbarSlider {
  0% {
    left: -100%;
  }
  50% {
    left: 0;
  }
  100% {
    left: 100%;
  }
}
.zoom_in {
  transform: scale(1.3) !important;
}

.cmsBody p {
  text-align: left !important;
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/common.scss"],"names":[],"mappings":"AA8BA;EACC,SAAA;EACA,UAAA;EACA,gCAAA;EACA,wBAAA;AA5BD;AA8BC;EACC,yBAAA;EACA,0BAAA;AA5BF;AA+BC;EACC,+CAAA;AA7BF;AAgCC;EACC,yBApCc;EAqCd,aAAA;AA9BF;AAiCC;EACC,2BAAA;AA/BF;;AAmCA;EACC,eAAA;AAhCD;AAkCC;EAHD;IAIE,eAAA;EA/BA;AACF;AAiCC;EAPD;IAQE,eAAA;EA9BA;AACF;AAoCC;EAfD;IAgBE,eAAA;EAjCA;AACF;AA2CA;EACC,iBAAA;EACA,qCA/EoB;EAgFpB,gBA9EoB;EA+EpB,gBA9EoB;EA+EpB,cA9EmB;AAqCpB;;AA4CA;EACC,yBAAA;AAzCD;;AA2CA;EACC,4BAAA;AAxCD;;AA4CC;EACC,oCAAA;AAzCF;AA4CC;EACC,oCAAA;AA1CF;AA6CC;EACC,oCAAA;AA3CF;;AA+CA;EAAM,gBAAA;AA3CN;;AA6CA;;EAEC,qBAAA;EACA,sBAAA;AA1CD;;AA6CA;EACC,UAAA;EACA,iBAAA;AA1CD;;AA6CA;EACC,qBAAA;EACA,sBAAA;AA1CD;;AA6CA;EACC,qBAAA;EACA,sBAAA;AA1CD;;AA6CA;EACC,8BAAA;AA1CD;AA+CE;;;;;;EAEC,0BAAA;EACA,kBAAA;AAzCH;;AA6CA;EACC,8BAAA;AA1CD;AA+CE;;;;;;EAEC,0BAAA;EACA,2BAAA;AAzCH;;AA6CA;EACC,gBAAA;AA1CD;;AA6CA;;;EAGC,uBAAA;EACA,oCAAA;EACA,kBAAA;AA1CD;AA4CC;;;EACC,gCAAA;AAxCF;;AA4CA;;;;;;EAMC,eAAA;EACA,kCAAA;AAzCD;;AA4CA;EACC,iBAAA;EACG,oCAAA;AAzCJ;;AA4CA;;;EAGC,2BAAA;AAzCD;;AA4CA;EACC,yBA5Le;AAmJhB;AA2CC;;EAEC,cA5LY;EA6LZ,UAAA;AAzCF;;AAiDA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AA/CD;AAiDC;EACC,wBAAA;EACA,iBAAA;AA/CF;AAkDC;EACC,sBAAA;EACA,eAAA;AAhDF;AAmDC;EACC,sBAAA;EACA,iBAAA;AAjDF;AAqDC;EACC,yBApOc;EAqOd,YAAA;EACA,yBAAA;AAnDF;AAqDE;EACC,yBAxOa;EAyOb,YAAA;AAnDH;AAuDC;EACC,cA/Oc;EAgPd,uBAAA;EACA,yBAAA;AArDF;AAuDE;EACC,yBApPa;EAqPb,YAAA;AArDH;;AA0DA;EACC,2BAAA;EACA,uBAAA;AAvDD;;AA0DA;EACC,iBAAA;AAvDD;;AA0DA;EACC,eAAA;AAvDD;;AA0DA;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvDD;;AA0DA;EACC,aAAA;EACA,eAAA;EAEA,mBAAA;EACA,UAAA;AAxDD;AA0DC;EACC,aAAA;EACA,sBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAzDF;AA2DE;EACC,gBAAA;AAzDH;AA4DE;EACC,cAAA;AA1DH;AA4DG;EACC,cAAA;AA1DJ;AA+DC;EACC,aAAA;EACA,eAAA;EAEA,SAAA;EACA,UAAA;AA9DF;AAgEE;EACC,aAAA;EACA,sBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AA/DH;AAmEG;EACC,gBAAA;AAjEJ;AAoEG;EACC,cAAA;AAlEJ;AAoEI;EACC,cAAA;AAlEL;;AAyEA;EACC,yGAAA;EACA,gCAAA;AAtED;AAwEC;EAJD;IAKE,yCAAA;EArEA;AACF;;AAwEA;EACC,qBAAA;AArED;;AAwEA;EACC,yBAAA;AArED;;AAwEA;EACC,aAAA;EACA,sBAAA;AArED;AAuEC;EACC,aAAA;EACA,8BAAA;EACA,eAAA;AArEF;AAuEE;EACC,aAAA;EACA,sBAAA;AArEH;AAuEG;EACC,WAAA;AArEJ;AAuEI;EACC,aAAA;EACA,sBAAA;AArEL;AAuEK;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EAEA,UAAA;EACA,kBAAA;AAtEN;AAwEM;EACC,gBAAA;AAtEP;AAyEM;EACC,UAAA;AAvEP;AAyEO;EAEC,SAAA;AAxER;AA4EO;EAEC,eAAA;AA3ER;AAkFG;EACC,UAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;AAhFJ;AAmFG;EACC,UAAA;EACA,kBAAA;EACA,kBAAA;AAjFJ;AAoFG;EACC,aAAA;EACA,sBAAA;EAEA,gBAAA;AAnFJ;AAqFI;EACC,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAnFL;AAuFG;EACC,aAAA;EACA,sBAAA;AArFJ;AAuFI;EACC,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,oCAAA;EACA,kBAAA;AAtFL;AAwFK;EACC,UAAA;EACA,mBAAA;EACA,SAAA;AAtFN;AAyFK;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAxFN;AA0FM;EACC,gBAAA;AAxFP;AA2FM;EACC,qBAAA;AAzFP;AA2FO;EACC,gBAAA;EACA,4BAAA;AAzFR;AA4FO;EACC,gBAAA;EACA,oBAAA;AA1FR;AA8FM;EACC,qBAAA;AA5FP;;AAqGA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,cAAA;AAlGD;AAoGC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAlGF;AAoGE;EACC,mEAAA;EACA,2BAAA;AAlGH;AAoGG;EACC,YAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBApgBY;EAqgBZ,2BAAA;AAlGJ;AAqGG;EACC,wBAAA;AAnGJ;AAqGI;EACC,YAAA;EACA,aAAA;AAnGL;AAuGG;EACC,wBAAA;AArGJ;AAuGI;EACC,WAAA;EACA,YAAA;AArGL;AAyGG;EACC,wBAAA;AAvGJ;AAyGI;EACC,YAAA;EACA,YAAA;AAvGL;AA2GG;EACC,wBAAA;AAzGJ;AA2GI;EACC,WAAA;EACA,UAAA;AAzGL;AA6GG;EACC,uBAAA;AA3GJ;AA6GI;EACC,YAAA;EACA,YAAA;AA3GL;AA+GG;EACC,wBAAA;AA7GJ;AA+GI;EACC,WAAA;EACA,YAAA;AA7GL;AAiHG;EACC,wBAAA;AA/GJ;AAiHI;EACC,YAAA;EACA,aAAA;AA/GL;AAmHG;EACC,wBAAA;AAjHJ;AAmHI;EACC,WAAA;EACA,YAAA;AAjHL;;AAwHA;EACC;IACC,uBAAA;EArHA;EAwHD;IACC,yBAAA;EAtHA;AACF;AAyHA;EACC;IACC,WAAA;EAvHA;EA0HD;IACC,OAAA;EAxHA;EA2HD;IACC,UAAA;EAzHA;AACF;AA4HA;EACC,gCAAA;AA1HD;;AA6HI;EACI,2BAAA;EACA,sBAAA;AA1HR","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n//@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');\r\n\r\n///* ----------- Default Styling Start --------------- */\r\n\r\n$primary-fontFamily: \"Montserrat\", sans-serif;\r\n//$primary-fontFamily: 'Inter', sans-serif;\r\n$primary-fontWeight: 400;\r\n$primary-lineHeight: 1.4;\r\n$primary-fontColor: #6e6b7b;\r\n$primary-color: #2056a5;\r\n$primary-hover: #1b427c;\r\n$primary-bgColor: #fafafa;\r\n$color-black: #000000;\r\n$color-white: #ffffff;\r\n\r\n/// Viewport\r\n$desktop_xxxl: 1920px;\r\n$desktop_xxl: 1650px;\r\n$desktop_xl: 1440px;\r\n$laptop: 1366px;\r\n$desktop: 1280px;\r\n$desktopSmall: 1024px;\r\n$tabletSmall: 768px;\r\n$mobileBig: 767px;\r\n$mobile: 480px;\r\n$mobileSmall: 360px;\r\n\r\n///* ----------- Default Styling End ----------------- */\r\n\r\n* {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\ttext-decoration: none !important;\r\n\toutline: none !important;\r\n\r\n\t&::-webkit-scrollbar {\r\n\t\twidth: 0.25rem !important;\r\n\t\theight: 0.25rem !important;\r\n\t}\r\n\r\n\t&::-webkit-scrollbar-track {\r\n\t\tbox-shadow: inset 0 0 0.3rem rgba(0, 0, 0, 0.3);\r\n\t}\r\n\r\n\t&::-webkit-scrollbar-thumb {\r\n\t\tbackground-color: $primary-color;\r\n\t\toutline: none;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tbox-shadow: none !important;\r\n\t}\r\n}\r\n\r\nhtml {\r\n\tfont-size: 20px;\r\n\r\n\t@media (max-width: $desktop_xl - 1) {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\r\n\t@media (max-width: $laptop - 1) {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\r\n\t// @media (max-width: $desktop - 1) {\r\n\t// \tfont-size: 14px;\r\n\t// }\r\n\r\n\t@media (max-width: $desktopSmall - 1) {\r\n\t\tfont-size: 12px;\r\n\t}\r\n\r\n\t// @media (max-width: $mobileBig) {\r\n\t// \tfont-size: 10px;\r\n\t// }\r\n\r\n\t@media (max-width: $mobile - 1) {\r\n\t}\r\n}\r\n\r\nbody {\r\n\tfont-size: 0.8rem;\r\n\tfont-family: $primary-fontFamily;\r\n\tfont-weight: $primary-fontWeight;\r\n\tline-height: $primary-lineHeight;\r\n\tcolor: $primary-fontColor;\r\n}\r\n\r\n.ml-0 {\r\n\tmargin-left: 0 !important;\r\n}\r\n.pb-0 {\r\n\tpadding-bottom: 0 !important;\r\n}\r\n\r\n.badge {\r\n\t&.bg-primary {\r\n\t\tbackground-color: $primary-color !important;\r\n\t}\r\n\r\n\t&.bg-success {\r\n\t\tbackground-color: #71d875 !important;\r\n\t}\r\n\r\n\t&.bg-warning {\r\n\t\tbackground-color: #f99240 !important;\r\n\t}\r\n}\r\n\r\n.mt40{margin-top: 40px;}\r\n\r\n.container-fluid,\r\n.container {\r\n\tpadding-left: 0.75rem;\r\n\tpadding-right: 0.75rem;\r\n}\r\n\r\n.container {\r\n\twidth: 96%;\r\n\tmax-width: 1440px;\r\n}\r\n\r\n.row {\r\n\tmargin-left: -0.75rem;\r\n\tmargin-right: -0.75rem;\r\n}\r\n\r\n[class*=\"col-\"] {\r\n\tpadding-left: 0.75rem;\r\n\tpadding-right: 0.75rem;\r\n}\r\n\r\n.table {\r\n\twhite-space: nowrap !important;\r\n\r\n\tthead,\r\n\ttbody,\r\n\ttfoot {\r\n\t\tth,\r\n\t\ttd {\r\n\t\t\tpadding: 0.6rem !important;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\t}\r\n}\r\n#customerGroup {\r\n\twhite-space: nowrap !important;\r\n\r\n\tthead,\r\n\ttbody,\r\n\ttfoot {\r\n\t\tth,\r\n\t\ttd {\r\n\t\t\tpadding: 0.6rem !important;\r\n\t\t\ttext-align: left!important;\r\n\t\t}\r\n\t}\r\n}\r\n.form-group {\r\n\tmargin: 0 0 1rem;\r\n}\r\n\r\n.form-control,\r\n.css-13cymwt-control,\r\n.css-1s2u09g-control {\r\n\tborder-radius: 0.375rem;\r\n\tbackground-color: $primary-bgColor !important;\r\n\tborder-color: #ccc;\r\n\r\n\t&:hover {\r\n\t\tborder-color: #86b7fe !important;\r\n\t}\r\n}\r\n\r\ninput[type=\"text\"].form-control,\r\ninput[type=\"date\"].form-control,\r\ntextarea.form-control,\r\n.css-319lph-ValueContainer,\r\n.css-1fdsijx-ValueContainer,\r\n.css-1d8n9bt {\r\n\tfont-size: 1rem;\r\n\tpadding: 0.45rem 0.9rem !important;\r\n}\r\n\r\ninput[type=\"date\"].form-control{\r\n\tfont-size: 0.8rem;\r\n    padding: 0.375rem 0.75rem !important;\r\n}\r\n\r\n.modal-header,\r\n.modal-body,\r\n.modal-footer {\r\n\tpadding: 0.75rem !important;\r\n}\r\n\r\n.modal-header {\r\n\tbackground-color: $primary-color;\r\n\r\n\t.modal-title,\r\n\t.btn-close {\r\n\t\tcolor: $color-white;\r\n\t\topacity: 1;\r\n\t}\r\n}\r\n\r\n// .modal-dialog {\r\n// \tmax-width: 60rem;\r\n// }\r\n\r\n.btn {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\r\n\tpadding: 0.3rem 0.6rem;\r\n\tfont-size: 0.8rem;\r\n\tborder-radius: 0.3rem;\r\n\ttransition: all 0.5s ease;\r\n\r\n\t&.btn-sm {\r\n\t\tpadding: 0.15rem 0.45rem;\r\n\t\tfont-size: 0.6rem;\r\n\t}\r\n\r\n\t&.btn-lg {\r\n\t\tpadding: 0.6rem 1.8rem;\r\n\t\tfont-size: 1rem;\r\n\t}\r\n\r\n\t&.btn-xl {\r\n\t\tpadding: 0.8rem 2.4rem;\r\n\t\tfont-size: 1.2rem;\r\n\t}\r\n\t\r\n\r\n\t&.btn-primary {\r\n\t\tbackground-color: $primary-color;\r\n\t\tcolor: white;\r\n\t\tborder: 1px solid $primary-color;\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground-color: $primary-hover;\r\n\t\t\tcolor: white;\r\n\t\t}\r\n\t}\r\n\r\n\t&.btn-outline-primary {\r\n\t\tcolor: $primary-color;\r\n\t\tbackground-color: white;\r\n\t\tborder: 1px solid $primary-color;\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground-color: $primary-color;\r\n\t\t\tcolor: white;\r\n\t\t}\r\n\t}\r\n}\r\n\r\ntextarea.form-control {\r\n\tmin-height: 5rem !important;\r\n\tresize: none !important;\r\n}\r\n\r\n.form-control {\r\n\tfont-size: 0.8rem;\r\n}\r\n\r\nimg {\r\n\tmax-width: 100%;\r\n}\r\n\r\n.characterLimitProperty {\r\n\tfont-weight: 400;\r\n\tmax-width: 100%;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.textValidatorError {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\r\n\tmargin-top: 0.25rem;\r\n\tcolor: red;\r\n\r\n\tp {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\r\n\t\tfont-size: 0.6rem;\r\n\t\tfont-weight: 700;\r\n\t\tline-height: 1.5;\r\n\t\tcolor: #8b8c8c;\r\n\t\tmargin: 0 0 0.5rem;\r\n\r\n\t\t&:nth-last-child(1) {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\r\n\t\tspan {\r\n\t\t\tdisplay: block;\r\n\r\n\t\t\t&.passwordAdded {\r\n\t\t\t\tcolor: #50bc14;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\tul {\r\n\t\tdisplay: flex;\r\n\t\tflex-wrap: wrap;\r\n\r\n\t\tmargin: 0;\r\n\t\tpadding: 0;\r\n\r\n\t\tli {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\r\n\t\t\tfont-size: 0.6rem;\r\n\t\t\tfont-weight: 700;\r\n\t\t\tline-height: 1.5;\r\n\t\t\tcolor: #8b8c8c;\r\n\t\t\tmargin: 0 0.5rem 0.5rem 0;\r\n\r\n\t\t\t// width: 50%;\r\n\r\n\t\t\t&:nth-last-child(1) {\r\n\t\t\t\tmargin-bottom: 0;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tdisplay: block;\r\n\r\n\t\t\t\t&.passwordAdded {\r\n\t\t\t\t\tcolor: #50bc14;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.selectArrow {\r\n\tbackground: transparent url(\"../Image/arrowDownIcon.jpg\") no-repeat right 0.5rem center / 0.6rem auto;\r\n\tpadding-right: 1.2rem !important;\r\n\r\n\t@media (max-width: $mobileBig) {\r\n\t\tbackground-position: right 0.25rem center;\r\n\t}\r\n}\r\n\r\n.errorMessage {\r\n\tcolor: red !important;\r\n}\r\n\r\n.successMessage {\r\n\tcolor: #50bc14 !important;\r\n}\r\n\r\n.dashboard__transactionsModal {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\r\n\t.dashboard__transactionsModalProfile {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\tflex-wrap: wrap;\r\n\r\n\t\t.dashboard__transactionsModalDetails {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\r\n\t\t\t&:nth-child(1) {\r\n\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t.dashboard__transactionsModalBottom {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tflex-direction: column;\r\n\r\n\t\t\t\t\tul {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\tflex-direction: row;\r\n\t\t\t\t\t\tflex-wrap: wrap;\r\n\r\n\t\t\t\t\t\tpadding: 0;\r\n\t\t\t\t\t\tmargin: 0 0 0.5rem;\r\n\r\n\t\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tli {\r\n\t\t\t\t\t\t\twidth: 50%;\t\t\t\t\t\t\t\r\n\r\n\t\t\t\t\t\t\t&:nth-last-child(2),\r\n\t\t\t\t\t\t\t&:nth-last-child(1) {\r\n\t\t\t\t\t\t\t\tmargin: 0;\r\n\t\t\t\t\t\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t&:nth-child(1){\r\n\t\t\t\t\t\t\t\t// margin: 0;\r\n\t\t\t\t\t\t\t\tpadding-left: 0;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:nth-child(2) {\r\n\t\t\t\twidth: 50%;\r\n\t\t\t\tpadding-right: 1rem;\r\n\t\t\t\tborder-right: 0.05rem solid #dee2e6;\r\n\t\t\t\tmargin-top: 1.5rem;\r\n\t\t\t}\r\n\r\n\t\t\t&:nth-child(3) {\r\n\t\t\t\twidth: 50%;\r\n\t\t\t\tpadding-left: 1rem;\r\n\t\t\t\tmargin-top: 1.5rem;\r\n\t\t\t}\r\n\r\n\t\t\t.dashboard__transactionsModalTop {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tflex-direction: column;\r\n\r\n\t\t\t\tmargin: 0 0 1rem;\r\n\r\n\t\t\t\th2 {\r\n\t\t\t\t\tfont-size: 0.9rem;\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tline-height: 1.2;\r\n\t\t\t\t\tcolor: #282828;\r\n\t\t\t\t\tmargin: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.dashboard__transactionsModalBottom {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tflex-direction: column;\r\n\r\n\t\t\t\tul {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tflex-direction: column;\r\n\r\n\t\t\t\t\tpadding: 0 0 0.5rem;\r\n\t\t\t\t\tborder-bottom: 0.05rem solid #dee2e6;\r\n\t\t\t\t\tmargin: 0 0 0.5rem;\r\n\r\n\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\tpadding: 0;\r\n\t\t\t\t\t\tborder-bottom: none;\r\n\t\t\t\t\t\tmargin: 0;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tli {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\tjustify-content: flex-start;\r\n\r\n\t\t\t\t\t\tfont-size: 0.7rem;\r\n\t\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\t\tline-height: 1.2;\r\n\t\t\t\t\t\tcolor: #282828;\r\n\t\t\t\t\t\tmargin: 0 0 0.7rem;\r\n\r\n\t\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tspan {\r\n\t\t\t\t\t\t\tdisplay: inline-block;\r\n\r\n\t\t\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\t\t\t\tmax-width: calc(100% - 8rem);\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t&:first-child {\r\n\t\t\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t\t\t\tmargin-right: 0.5rem;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\ta {\r\n\t\t\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.mainPreloaderMain {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: rgba(#f2f2f2, 0.9);\r\n\tz-index: 99999;\r\n\r\n\t.mainPreloader {\r\n\t\tposition: absolute;\r\n\t\ttop: 50%;\r\n\t\tleft: 50%;\r\n\t\ttransform: translate(-50%, -50%);\r\n\t\twidth: 4rem;\r\n\t\theight: 4rem;\r\n\t\tz-index: 99999;\r\n\r\n\t\tdiv {\r\n\t\t\tanimation: mainPreloader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\r\n\t\t\ttransform-origin: 2rem 2rem;\r\n\r\n\t\t\t&:after {\r\n\t\t\t\tcontent: \" \";\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\twidth: 0.35rem;\r\n\t\t\t\theight: 0.35rem;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tbackground: $primary-color;\r\n\t\t\t\tmargin: -0.2rem 0 0 -0.2rem;\r\n\t\t\t}\r\n\r\n\t\t\t&:nth-child(1) {\r\n\t\t\t\tanimation-delay: -0.036s;\r\n\r\n\t\t\t\t&:after {\r\n\t\t\t\t\ttop: 3.15rem;\r\n\t\t\t\t\tleft: 3.15rem;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:nth-child(2) {\r\n\t\t\t\tanimation-delay: -0.072s;\r\n\r\n\t\t\t\t&:after {\r\n\t\t\t\t\ttop: 3.4rem;\r\n\t\t\t\t\tleft: 2.8rem;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:nth-child(3) {\r\n\t\t\t\tanimation-delay: -0.108s;\r\n\r\n\t\t\t\t&:after {\r\n\t\t\t\t\ttop: 3.55rem;\r\n\t\t\t\t\tleft: 2.4rem;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:nth-child(4) {\r\n\t\t\t\tanimation-delay: -0.144s;\r\n\r\n\t\t\t\t&:after {\r\n\t\t\t\t\ttop: 3.6rem;\r\n\t\t\t\t\tleft: 2rem;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:nth-child(5) {\r\n\t\t\t\tanimation-delay: -0.18s;\r\n\r\n\t\t\t\t&:after {\r\n\t\t\t\t\ttop: 3.55rem;\r\n\t\t\t\t\tleft: 1.6rem;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:nth-child(6) {\r\n\t\t\t\tanimation-delay: -0.216s;\r\n\r\n\t\t\t\t&:after {\r\n\t\t\t\t\ttop: 3.4rem;\r\n\t\t\t\t\tleft: 1.2rem;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:nth-child(7) {\r\n\t\t\t\tanimation-delay: -0.252s;\r\n\r\n\t\t\t\t&:after {\r\n\t\t\t\t\ttop: 3.15rem;\r\n\t\t\t\t\tleft: 0.85rem;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:nth-child(8) {\r\n\t\t\t\tanimation-delay: -0.288s;\r\n\r\n\t\t\t\t&:after {\r\n\t\t\t\t\ttop: 2.8rem;\r\n\t\t\t\t\tleft: 0.6rem;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@keyframes mainPreloader {\r\n\t0% {\r\n\t\ttransform: rotate(0deg);\r\n\t}\r\n\r\n\t100% {\r\n\t\ttransform: rotate(360deg);\r\n\t}\r\n}\r\n\r\n@keyframes progressbarSlider {\r\n\t0% {\r\n\t\tleft: -100%;\r\n\t}\r\n\r\n\t50% {\r\n\t\tleft: 0;\r\n\t}\r\n\r\n\t100% {\r\n\t\tleft: 100%;\r\n\t}\r\n}\r\n\r\n.zoom_in{\r\n\ttransform: scale(1.3) !important;\r\n}\r\n.cmsBody {\r\n    p {\r\n        text-align: left !important;\r\n        width: 100% !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
